var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephoneDarkBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 194,
    viewBox: "0 0 216 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7341_50587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.812 135.303H83.1901L69.1133 186.684H146.891L132.812 135.303Z",
    fill: "#131111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.89 187.195H69.1128C68.9536 187.195 68.8036 187.121 68.7063 186.995C68.6089 186.868 68.578 186.702 68.6197 186.549L82.6965 135.167C82.7568 134.944 82.9593 134.791 83.1896 134.791H132.812C133.042 134.791 133.245 134.946 133.305 135.167L147.382 186.549C147.423 186.702 147.393 186.868 147.295 186.995C147.199 187.121 147.048 187.195 146.889 187.195H146.89ZM69.7821 186.174H146.219L132.422 135.814H83.5791L69.7821 186.174Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.058 1H8.91871C4.54533 1 1 4.54533 1 8.91871V144.766C1 149.139 4.54533 152.684 8.91871 152.684H207.058C211.431 152.684 214.977 149.139 214.977 144.766V8.91871C214.977 4.54533 211.431 1 207.058 1Z",
    fill: "#131111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.07 152.706H8.93034C4.28237 152.706 0.5 148.925 0.5 144.277V8.4288C0.5 3.78082 4.28237 0 8.93034 0H207.07C211.718 0 215.5 3.78082 215.5 8.4288V144.276C215.5 148.924 211.718 152.705 207.07 152.705V152.706ZM8.93034 1.02172C4.84501 1.02172 1.52172 4.34501 1.52172 8.4288V144.276C1.52172 148.36 4.84501 151.683 8.9288 151.683H207.068C211.153 151.683 214.475 148.36 214.475 144.276V8.4288C214.475 4.34501 211.152 1.02172 207.068 1.02172H8.93034Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 191,
    height: 128,
    rx: 9,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.337 181.405H60.666C57.9456 181.405 55.7383 183.611 55.7383 186.333C55.7383 189.055 57.944 191.261 60.666 191.261H155.337C158.057 191.261 160.264 189.055 160.264 186.333C160.264 183.611 158.059 181.405 155.337 181.405Z",
    fill: "#131111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.335 191.771H60.6644C57.6657 191.771 55.2266 189.332 55.2266 186.333C55.2266 183.335 57.6657 180.896 60.6644 180.896H155.335C158.334 180.896 160.773 183.335 160.773 186.333C160.773 189.332 158.334 191.771 155.335 191.771ZM60.6644 181.917C58.2299 181.917 56.2483 183.899 56.2483 186.333C56.2483 188.768 58.2299 190.749 60.6644 190.749H155.335C157.769 190.749 159.751 188.768 159.751 186.333C159.751 183.899 157.769 181.917 155.335 181.917H60.6644Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.81 76.9219H142.776C140.403 76.9219 138.48 78.7551 138.48 81.0165V188.591C138.48 190.852 140.403 192.685 142.776 192.685H200.81C203.183 192.685 205.106 190.852 205.106 188.591V81.0165C205.106 78.7551 203.183 76.9219 200.81 76.9219Z",
    fill: "#131111"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 81,
    width: 58,
    height: 108,
    rx: 4,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.809 193.255H142.775C140.078 193.255 137.883 191.163 137.883 188.591V81.0169C137.883 78.4449 140.078 76.3535 142.775 76.3535H200.809C203.506 76.3535 205.701 78.4449 205.701 81.0169V188.591C205.701 191.163 203.506 193.255 200.809 193.255ZM142.775 77.4927C140.736 77.4927 139.078 79.074 139.078 81.0169V188.591C139.078 190.534 140.736 192.115 142.775 192.115H200.809C202.848 192.115 204.506 190.534 204.506 188.591V81.0169C204.506 79.074 202.848 77.4927 200.809 77.4927H142.775Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.794 85.6446C170.864 85.6446 170.109 84.9259 170.109 84.0386C170.109 83.1514 170.864 82.4326 171.794 82.4326C172.725 82.4326 173.479 83.1514 173.479 84.0386C173.479 84.9259 172.725 85.6446 171.794 85.6446Z",
    fill: "#989898"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7341_50587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 193.255,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneDarkBank);
export default __webpack_public_path__ + "static/media/telephone-dark-bank.fa24aec27323ff73a681fecfc84bef7f.svg";
export { ForwardRef as ReactComponent };